export function getSizeWidth(sizeId: string): number {
    switch (sizeId) {
        case "4x6":
            return 6;
        case "6x9":
            return 9;
        case "6x11":
            return 11;
        case "11x8.5":
            return 8.5;
        default:
            return 6;
    }
}

export function getSizeHeight(sizeId: string): number {
    switch (sizeId) {
        case "4x6":
            return 4;
        case "6x9":
            return 6;
        case "6x11":
            return 6;
        case "11x8.5":
            return 11;
        default:
            return 4;
    }
}

export function maskKey(key: string, maskLength = 12) {
  const lengthToMask = Math.min(maskLength, key.length);
  return key.slice(0, -lengthToMask) + 'x'.repeat(lengthToMask);
}
